import { toRGBA } from "./utils";

const pebbles = [250, 242, 228];
const p = (opacity: number = 1) =>
  toRGBA(pebbles[0], pebbles[1], pebbles[2], opacity);

export default p;
